// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"9076951e","783":"2aa132d1","787":"68f0e43b","872":"04a2deb7"}[chunkId] + ".chunk.js";
};